import * as z from "zod";

/** Whether the signed-in user has connected an assistant to the public MCP. */
export const getIsMcpConnected = {
  name: "getIsMcpConnected" as const,
  input: z.object({}),
  output: z.object({ isConnected: z.boolean() }),
};
